import VideoTemplate from '../../../template/VideoTemplate.js'
import Webview from "../../../component/native/visible/Webview";
import PlayerView from "../../../component/native/visible/PlayerView";
import App from "../../../App";
import {getFilePathByRemoteUrl} from '@src/common/util'
import SubplayTemplateView from "../../../component/native/visible/SubplayTemplateView";
import Template from "../../Template";

export default class OldVideoDemo extends Template {
    constructor(props = {}) {
        console.log('初始化OldVideoDemo')
        super(props)
        this.campaign = props.campaign || {}
        console.log('初始化OldVideoDemo+')
    }


    initComponents() {
        const imgURL = this.campaign && this.campaign.image_url
        let img = new Image()
        img.src = imgURL
        img.style.width='100%'
        img.style.height='100%'
        img.style.position='absolute'
        img.style.top='0'
        img.style.left='0'
        document.body.appendChild(img)

        //this.campaign.rv.template_url = "https://hybird.rayjump.com/rv-zip-2019/1125/tpl2-blurry-06873529417cac43dfa83fe16067ae8a.zip?md5filename=06873529417cac43dfa83fe16067ae8a\u0026foldername=tpl2-blurry\u0026layout=5\u0026tpl=2\u0026wfr=1\u0026to=9999\u0026type4=true"
        this.tplComp = new SubplayTemplateView({
            campaign: this.campaign,
            unitId: this.unit.id,
            unitSetting: this.unit.setting,
        })
        this.tplComp.preload().then(()=>{
            //this.tplComp.appendTo(this.container)
            console.log('do fullScreenShow',this.tplComp.id)
            App.fullScreenShow(this.tplComp.id)
        })
    }

    adShowed(data) {
        console.log('创建SubplayTemplateView ：：：',data)
        super.adShowed(data)

        this.tplComp.setInfo({
            userId: data.param.userId,
            reward: data.param.reward,
        })

        this.tplComp.onLoad((data)=>{
            console.log('this.tplComp.onLoad',this.tplComp.id)
            //App.fullScreenShow(this.tplComp.id)
        })
        console.log('initComponents OldVideoDemo2')
    }

    bindPageEvent() {
        super.bindPageEvent()
    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {

    }

    initSlots() {
        super.initSlots()
    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish(){
        return Promise.all([
            super._isLoadFinish(),
        ])
    }
}